class ErLink {
  constructor(source, target, isOneToMany) {
    this._source = source; // ColumnRef
    this._target = target; // ColumnRef
    this._isOneToMany = isOneToMany; // true if source is a primary key
  }

  source() {
    return this._source;
  }

  target() {
    return this._target;
  }

  isOneToMany() {
    return this._isOneToMany;
  }
}

export default ErLink;
